query DashboardWebSdkTests(
    $offset: Int!
    $limit: Int!
    $sort: wsdk_test_runsSort
    $daysAmountFilter: ConditionInt
    $customFieldsFilter: ConditionStringArray
    $customFieldsFilterExcludes: ConditionStringArray
    $environmentCustomFieldsFilter: ConditionStringArray
    $environmentsFilter: ConditionString
) {
    wsdk_test_runs(
        offset: $offset
        limit: $limit
        sort: $sort
        run_time_last_n_days: $daysAmountFilter
        custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
                    { environments_eq_any_item: $environmentsFilter }
                ]
            }
            { custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
        ]
    ) {
        run_id
        test_name
        total_issues
        critical_issues
        serious_issues
        run_time
        custom_fields
        environments
        flows
        test_path
    }
    total: wsdk_test_runs(
        run_time_last_n_days: $daysAmountFilter
        custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
                    { environments_eq_any_item: $environmentsFilter }
                ]
            }
            { custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
        ]
    ) {
        run_id_count
    }
    unfiltered_total: wsdk_test_runs {
        run_id_count
    }
}

query DashboardWebSdkRecentTests(
    $offset: Int!
    $limit: Int!
    $sort: wsdk_latest_test_runsSort
    $daysAmountFilter: ConditionInt
    $customFieldsFilter: ConditionStringArray
    $customFieldsFilterExcludes: ConditionStringArray
    $environmentCustomFieldsFilter: ConditionStringArray
    $environmentsFilter: ConditionString
) {
    wsdk_latest_test_runs(
        offset: $offset
        limit: $limit
        sort: $sort
        run_time_last_n_days: $daysAmountFilter
        custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
                    { environments_eq_any_item: $environmentsFilter }
                ]
            }
            { custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
        ]
    ) {
        run_id
        test_name
        total_issues
        critical_issues
        serious_issues
        run_time
        custom_fields
        environments
        flows
        test_path
    }
    total: wsdk_latest_test_runs(
        run_time_last_n_days: $daysAmountFilter
        custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
                    { environments_eq_any_item: $environmentsFilter }
                ]
            }
            { custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
        ]
    ) {
        run_id_count
    }
    unfiltered_total: wsdk_test_runs {
        run_id_count
    }
}
